import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiArrowRight} = FiIcons;

export default function CartClaimButton({onClick,disabled,compact=false}) {
  return (
    <motion.button
      onClick={onClick}
      disabled={disabled}
      animate={disabled ? {} : {scale: [1,1.025,1]}}
      transition={{duration: 1.7,repeat: Infinity,ease: 'easeInOut'}}
      whileHover={disabled ? {} : {scale: 1.04,y: -3}}
      whileTap={disabled ? {} : {scale: 0.98}}
      className={`group relative flex w-full items-center justify-center gap-3 overflow-hidden rounded-2xl border-2 border-[#003d67] bg-[#004d80] px-6 font-extrabold text-white shadow-xl shadow-blue-900/30 transition hover:bg-[#003d67] hover:shadow-2xl disabled:cursor-not-allowed disabled:border-slate-400 disabled:bg-slate-400 ${
        compact ? 'py-4 text-sm sm:text-base' : 'py-5 text-base'
      }`}
    >
      <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent transition-transform duration-1000 group-hover:translate-x-full" />
      <span className="relative">See a Doctor &amp; Claim 35% Off</span>
      <SafeIcon
        icon={FiArrowRight}
        className="relative h-5 w-5 transition-transform group-hover:translate-x-1"
      />
    </motion.button>
  );
}